<template>
  <div>
    <course-list v-show="tabType === 1" @handleShow="handleShow" :sourceType="2" />
    <course-show v-if="tabType === 2" :rowItem="rowItem" :sourceType="sourceType" @handleShow="handleShow" />
    <repair-plan-list v-if="tabType === 3" :rowItem="rowItem" @handleShow="handleShow" />
    <chapter-list v-if="tabType === 4" :rowItem="rowItem" @handleShow="handleShow" />
    <courseware-list v-if="tabType === 5" :rowItem="rowItem" @handleShow="handleShow" />
    <lecturer-show v-if="tabType === 6" :isCourse="1" :rowItem="rowItem" @handleShow="handleShow" />
  </div>
</template>

<script>
import courseList from './list.vue'
import repairPlanList from './repairPlan/index.vue'
import chapterList from './chapter/index.vue'
import coursewareList from './courseware/index.vue'
import courseShow from './show.vue'
import lecturerShow from '../lecturer/show.vue'
export default {
  components: { courseList, repairPlanList, chapterList, coursewareList, courseShow, lecturerShow },
  data() {
    return {
      tabType: 1,
      rowItem: null,
      sourceType: 1
    }
  },
  methods: {
    handleShow(row, type, sourceType) {
      this.rowItem = { ...row }
      this.sourceType = sourceType
      this.tabType = type
    }
  }


}
</script>

<style>
</style>